const endpoint = path => `/enterprise/v1/purchase${path}`;

const purchases = ({ post }) => ({
  postPurchase: (data, opts) => post(endpoint(""), data, opts)
});

export default purchases;